"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHelper = void 0;
var pinpo_model_kit_1 = require("pinpo-model-kit");
var ErrorHelper = /** @class */ (function () {
    function ErrorHelper() {
    }
    ErrorHelper.humanize = function (error, t) {
        var code = pinpo_model_kit_1.ErrorService.retreiveErrorCode(error);
        return {
            text: t ? t("error.code." + code) : "Oops... Something went wrong",
            subtext: (t ? t("general.error") : "Error") + " " + code
        };
    };
    return ErrorHelper;
}());
exports.ErrorHelper = ErrorHelper;
//# sourceMappingURL=ErrorHelper.js.map